import Tabs from 'src/components/Tabs';
import ServiceLog from 'src/pages/ServiceRequest/ServiceLog';
import ServiceRequestNotes from 'src/pages/ServiceRequest/ServiceRequestNotes';
import { PATHS } from 'src/common/constants';
import ServiceRequestMessages from 'src/pages/ServiceRequest/ServiceRequestMessages';
import ServiceRequestDetails from 'src/pages/ServiceRequest/ServiceRequestDetails';
import ServiceRequestDocuments from 'src/pages/ServiceRequest/ServiceRequestDocuments/ServiceRequestDocuments';
import { useServiceRequestDataFromContext } from 'src/pages/ServiceRequest/Context/ServiceRequestContext';
import { useServiceRequestNotesDataFromContext } from 'src/pages/ServiceRequest/Context/ServiceRequestNotesContext';

interface ServiceRequestTabsProps {
  user: any;
  requestId: string;
  activeTab: number;
  history: any;
  noteVisibleToHomeownerOccupantRealtor: boolean;
  matchId: string;
}

const ServiceRequestTabs = ({
  user,
  requestId,
  activeTab,
  history,
  noteVisibleToHomeownerOccupantRealtor,
  matchId,
}: ServiceRequestTabsProps) => {
  const userRole: any = user.roles[0].role.name;

  const { serviceRequest, messages, documents } =
    useServiceRequestDataFromContext();
  const { notes } = useServiceRequestNotesDataFromContext();

  const isHomeOwnerRealtorOccupant: boolean =
    userRole === 'Home Owner' ||
    userRole === 'Realtor' ||
    userRole === 'Occupant';

  const isPropertyManagerRole: boolean =
    userRole === 'Property Developer' ||
    userRole === 'Strata Manager' ||
    userRole === 'Service Manager' ||
    userRole === 'Service Provider';

  const tabItems: any = [
    {
      label: 'Details',
      content: (
        <ServiceRequestDetails serviceRequest={serviceRequest} user={user} />
      ),
    },
    {
      label: 'Messages',
      count: messages.length.toString(),
      content: (
        <ServiceRequestMessages
          serviceRequestId={requestId}
          history={history}
          url={PATHS.SERVICE_REQUESTS_VIEW.replace(':id', matchId)}
          ticketNumber={null}
        />
      ),
    },
    {
      label: 'Photos & Documents',
      count: documents.length.toString(),
      content: <ServiceRequestDocuments />,
    },
  ];

  if (!(isHomeOwnerRealtorOccupant && !noteVisibleToHomeownerOccupantRealtor)) {
    tabItems.push({
      label: 'Notes',
      count: notes.length.toString(),
      content: <ServiceRequestNotes />,
    });
  }

  if (isPropertyManagerRole) {
    tabItems.push({
      label: 'Service Log',
      content: (
        <ServiceLog
          serviceRequestId={requestId}
          actualTime={serviceRequest.actualTime}
          estimatedTime={serviceRequest.estimatedTime}
        />
      ),
    });
  }

  return (
    <div className="serviceRequest__tabs">
      <Tabs from={undefined} activeTab={activeTab} items={tabItems} />
    </div>
  );
};

export default ServiceRequestTabs;
